/**
 * @generated SignedSource<<eb40d5ff1f5f0b9f00bba22d1612c457>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApiKeySectionAdminEnableApiKeyMutation$variables = {
  id: string;
};
export type ApiKeySectionAdminEnableApiKeyMutation$data = {
  readonly adminEnableApiKey: {
    readonly enabledApiKeyId: string;
  } | null;
};
export type ApiKeySectionAdminEnableApiKeyMutation = {
  response: ApiKeySectionAdminEnableApiKeyMutation$data;
  variables: ApiKeySectionAdminEnableApiKeyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AdminEnableApiKey",
    "kind": "LinkedField",
    "name": "adminEnableApiKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabledApiKeyId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ApiKeySectionAdminEnableApiKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApiKeySectionAdminEnableApiKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3df89beac5ee05bb68570396563e78ea",
    "id": null,
    "metadata": {},
    "name": "ApiKeySectionAdminEnableApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation ApiKeySectionAdminEnableApiKeyMutation(\n  $id: ID!\n) {\n  adminEnableApiKey(id: $id) {\n    enabledApiKeyId\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e3d8d93ecd555947d7a0d07a1bc6b82";

export default node;
